<template>
  <div class="flex flex-col h-screen justify-center items-center">
    <div
      class="flex flex-col items-center gap-3 border-1 border-surface-200 rounded-lg login-panel"
    >
      <h1 class="mb-4">Phottr</h1>
      <Button @click="signInWithApple">Login with Apple</Button>
      <Button @click="signInWithGoogle">Login with Google</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from './auth';
import Button from 'primevue/button';

const { signInWithApple, signInWithGoogle } = useAuth();
</script>

<style scoped>
.login-panel {
  padding: 3rem 10rem;
}
</style>
